import { useAuth } from "@/context/AuthContext";
import Dashboard from "@/pages/Dashboard";
import MyWork from "@/pages/MyWork";

export default function Home() {
  const { user } = useAuth();
  return ["operatore", "caposquadra"].includes(user.role) ? <MyWork /> : <Dashboard />;
}

export const Hero = ({ user, subtitle, right }) => (
  <div className="brand-gradient -mx-4 -mt-6 mb-6 rounded-b-[28px] px-5 pb-7 pt-6 text-white sm:mx-0 sm:mt-0 sm:rounded-[28px] sm:px-8 fade-up" data-testid="dashboard-hero">
    <div className="flex items-start justify-between gap-4">
      <div>
        <h1 className="text-3xl font-extrabold tracking-tight sm:text-4xl">Ciao, {user.name.split(" ")[0]}</h1>
        <p className="mt-1 text-sm font-medium text-white/85">{subtitle}</p>
      </div>
      {right}
    </div>
  </div>
);
